import { Observable } from "rxjs/Observable";

/**
 * Defines avialable operations to be done on IndexedDB data for this web app.
 */
export interface IDataStore {
    getDocuments<T>(key: DatabaseKey): Observable<T>;
    insertDocument<T>(document: T, key: DatabaseKey): Observable<Observable<T>>;
    clear(): Observable<boolean>;
}
/**
 * Defines avialable keys to be used to retrieve data from database.
 * Note that Database schema is setup to be key/value pairs.
 */
export enum DatabaseKey {
    user = "user",
    users = "users",
    result = "result",
    results = "results",
    organisation = "organisation",
    courses = "courses"
}


// WEBPACK FOOTER //
// ./src/repository/IDataStore.ts